"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringDamageEventHandlerActivator = exports.RecurringDamageEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class RecurringDamageEventHandlerArgs {
    constructor(attackerId, target, damage) {
        this.attackerId = attackerId;
        this.target = target;
        this.damage = damage;
        this.__type = EventHandlerType_1.EventHandlerType.RecurringDamage;
        this.__typeName = "RecurringDamage";
    }
}
exports.RecurringDamageEventHandlerArgs = RecurringDamageEventHandlerArgs;
let RecurringDamageEventHandlerActivator = class RecurringDamageEventHandlerActivator {
    activate(sequence, container, handler, event) {
        const { target, attackerId, damage } = handler.args;
        container.selectLivingTargets(event.subject, target)
            .forEach(targetId => {
            container.applyDoTDamageV2({
                sequence,
                attackerId,
                targetId,
                damage
            });
        });
    }
};
RecurringDamageEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.RecurringDamage)
], RecurringDamageEventHandlerActivator);
exports.RecurringDamageEventHandlerActivator = RecurringDamageEventHandlerActivator;
